module.exports = "<app-nav></app-nav>\n<div class=\"row mr-0\" style=\"margin-bottom: 0px;\">\n    <app-sidenavbar class=\"col-xl-2 col-lg-2 col-md-3\" id=\"sidenav\"></app-sidenavbar>\n    <app-dashboard class=\"col-xl-10 col-lg-10 col-md-9 col-sm-12\" \n        style=\"background-color: #ffffff;\"></app-dashboard>\n</div>\n<app-footer></app-footer>\n<app-notification></app-notification>"


//////////////////
// WEBPACK FOOTER
// ./src/app/gerenciador/gerenciador.component.html
// module id = ./src/app/gerenciador/gerenciador.component.html
// module chunks = main